export default __webpack_public_path__ + "static/media/BSE_logo.f1752a74.svg";